import {PROJECT_BASE_PATH} from '../workspace/multiRunWorkspacePaths';

export const NOTEBOOKS_PATH = '/notebooks';
export const NOTEBOOKS_GETTING_STARTED_PATH = '/notebooks/getting-started';
export const NOTEBOOKS_OVERVIEW_PATH = '/notebooks/overview';
export const NOTEBOOKS_HOME_PATHS = [
  NOTEBOOKS_PATH,
  NOTEBOOKS_GETTING_STARTED_PATH,
  NOTEBOOKS_OVERVIEW_PATH,
];
export const FORGE_NOTEBOOK_PATH = `${NOTEBOOKS_PATH}/:notebookId`;

export const PROJECT_NOTEBOOKS_PATH = `${PROJECT_BASE_PATH}/:tab(notebooks)`;
export const MARIMO_NOTEBOOK_EDIT_PATH = `${PROJECT_NOTEBOOKS_PATH}/:notebookId/edit`;

export type NotebookRuntimeTarget = 'forge' | 'project';

export function marimoNotebookRuntimePath({
  entityName,
  notebookId,
  projectName,
  target,
}: {
  entityName?: string;
  notebookId: string;
  projectName?: string;
  target: NotebookRuntimeTarget;
}): string {
  if (target === 'forge') {
    return `${NOTEBOOKS_PATH}/${encodeURIComponent(notebookId)}`;
  }

  return marimoNotebookEditPath({
    entityName: entityName ?? '',
    notebookId,
    projectName: projectName ?? '',
  });
}

export function getNotebookRuntimeTarget(
  isShellMounted: boolean
): NotebookRuntimeTarget {
  if (isShellMounted) {
    return 'forge';
  }

  return 'project';
}

export function projectNotebooksPath({
  entityName,
  projectName,
}: {
  entityName: string;
  projectName: string;
}): string {
  return `/${entityName}/${projectName}/notebooks`;
}

export function marimoNotebookEditPath({
  notebookId,
  entityName,
  projectName,
}: {
  notebookId: string;
  entityName: string;
  projectName: string;
}): string {
  return `/${entityName}/${projectName}/notebooks/${encodeURIComponent(
    notebookId
  )}/edit`;
}
